import { motion } from "framer-motion";

import JusticeScaleIcon from "./JusticeScaleIcon";

const AddConditionIcon = ({ isEdgeSelected }: { isEdgeSelected: boolean }) => {
  // Don't compensate for parent scale - let it scale with the parent
  const compensateScale = 1;

  return (
    <g transform={`scale(${compensateScale})`}>
      <JusticeScaleIcon stroke={isEdgeSelected ? "#3b82f6" : "#ffffff"} x={-12} y={-12} />

      {/* "Add condition" text positioned above the circle - only show when not selected */}
      {!isEdgeSelected && (
        <motion.text
          x="0"
          y="-22"
          textAnchor="middle"
          fontSize="12"
          fontWeight="500"
          fill="#6b7280"
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.6, opacity: 0 }}
          transition={{ duration: 0.2, delay: 0.15 }}
          className="pointer-events-none select-none"
        >
          Add condition
        </motion.text>
      )}
    </g>
  );
};

export default AddConditionIcon;
